import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import PartnerForm from "@/components/PartnerForm";

export default function Partners() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <div className="pt-20">
        <PartnerForm />
      </div>
      <Footer />
    </div>
  );
}
